import { ChangeEvent, Key } from "react";

import { EnumHelper } from "@/Common/Helpers/EnumHelper";
import { Timeframe, TimeframeUnit } from "@/Common/Models/Timeframe";

interface TimeframeInputProps {
    readonly key?: Key;
    readonly name?: string;
    readonly label: string;
    readonly error?: string;
    readonly value: Timeframe;
    readonly disabled?: boolean;
    readonly onChange?: (value: Timeframe, name?: string) => void;
}

function TimeframeInput(props: TimeframeInputProps): JSX.Element {
    const { key, name, label, error, value, disabled, onChange } = props;

    const className = `form-group ${error && "has-error"}`;

    function handleValueChange(e: ChangeEvent<HTMLInputElement | HTMLSelectElement>): void {
        onChange?.({ ...value, Value: parseInt(e.target.value) }, name);
    }

    function handleUnitChange(e: ChangeEvent<HTMLInputElement | HTMLSelectElement>): void {
        onChange?.({ ...value, Unit: EnumHelper.getValue(TimeframeUnit, parseInt(e.target.value)) }, name);
    }

    return (
        <div key={key} className={className}>
            <div className="form-group-inline">
                <input
                    required
                    min={1}
                    value={value?.Value ?? 0}
                    onChange={handleValueChange}
                    type="number"
                    className="form-control"
                    disabled={disabled}
                />

                <select
                    required
                    value={EnumHelper.getValue(TimeframeUnit, value?.Unit ?? TimeframeUnit.Hour)}
                    onChange={handleUnitChange}
                    className="form-control"
                    disabled={disabled}
                >
                    {EnumHelper.getNamesAndValues(TimeframeUnit).map(timeframeUnit => (
                        <option key={timeframeUnit.value} value={timeframeUnit.value}>
                            {cacheStore.GetString(`${timeframeUnit.name}${value?.Value == 1 ? "" : "s"}Label`)}
                        </option>
                    ))}
                </select>

                <label className="control-label label">{label}</label>
            </div>

            {error && <span className="help-block">{error}</span>}
        </div>
    );
}

export { TimeframeInput };
